import React from 'react';
import { DefaultDropdownProps, Option, useFormContext, LoadDropdown } from 'framework/form';
import { get } from 'lodash';
import useNewProjectService from '../newProjectService';
import { ProjectSuggestionsDto } from '../types';

type RelatedDiscoveryOpportunityInputDropdownProps = DefaultDropdownProps & {
  accountAliasSource: string;
};

const ProjectsByAccountDropdown: React.FC<RelatedDiscoveryOpportunityInputDropdownProps> = ({
  accountAliasSource,
  source,
  ...props
}: RelatedDiscoveryOpportunityInputDropdownProps) => {
  const { searchSuggestions } = useNewProjectService();
  const { data = {} } = useFormContext();
  const accountId = get(data, accountAliasSource);

  const loadProjects = async () => {
    if (!accountId) return [];

    const request = {
      filter: {
        accountId: { eq: accountId },
      },
      pageNumber: 0,
      pageSize: 100,
    };

    return searchSuggestions(request);
  };

  const mapResults = (opp: any) => ({
    value: Number(opp.legacyId),
    label: opp.name,
  });

  const mapResult = (projects: ProjectSuggestionsDto[]): any[] => {
    const activeProjects: Option[] = [{ value: 'section', label: 'Active project', disabled: true }];
    const inactiveProjects: Option[] = [{ value: 'section', label: 'Inactive project', disabled: true }];
    projects?.forEach(project => {
      if (project.isArchived) {
        inactiveProjects.push({ value: project.legacyId, label: project.name });
      } else {
        activeProjects.push({ value: project.legacyId, label: project.name });
      }
    });

    if (activeProjects.length > 1 && inactiveProjects.length > 1) {
      return [...activeProjects, ...inactiveProjects];
    } else if (activeProjects.length === 1 && inactiveProjects.length > 1) {
      return inactiveProjects;
    } else if (activeProjects.length > 1 && inactiveProjects.length === 1) {
      return activeProjects;
    } else {
      return [];
    }
  };

  const customStyles = {
    option: (provided: any, state: any) => {
      return {
        ...provided,
        paddingLeft: state.data.value === 'section' ? provided.paddingLeft : '24px !important',
      };
    },
  };

  return (
    <LoadDropdown
      source={source}
      loadDataMethod={loadProjects}
      mapResult={mapResult}
      mapResults={mapResults}
      styles={customStyles}
      showLoader
      placeholder="Select project"
      deps={[accountId]}
      {...props}
    />
  );
};

export default ProjectsByAccountDropdown;
